import React from 'react';
import usePartnersPartner from './hooks';
import AddHeader from '../../../../../components/layout/header/add';
import Form from '../../../../../components/molecules/forms';
import CommissionType from '../../../clients/utils/commission-type';
import { DollarSign, Percentage } from '../../../../../components/atoms/icons';
import PartnersEditBottomButton from '../bottom-button';

interface Props {
  // eslint-disable-next-line react/require-default-props
  formikParent?: any
}

function PartnersPartner(props: Props) {
  const { formikParent } = props;
  const {
    commission, partner, partnerId, formik, isEdit, updateLoad, state,
  } = usePartnersPartner(formikParent);

  const renderFormContent = () => (
    <div>
      {isEdit && (
      <AddHeader
        primary={{ route: '/partners', title: 'Partner' }}
        secondary={{
          route: `/partners/${partnerId}`,
          title: partner?.data?.name,
        }}
        title="Edit Partner Detail"
      />
      )}
      <div className="px-4 px-xl-5 mb-5">
        <div className="fw-bold fz-16 mb-4">
          {`${partnerId ? 'Edit' : 'Add'} Partner Detail`}
        </div>
        <Form.Default
          id="name"
          placeholder="Enter Partner Name"
          label="Partner Name"
          className="mb-4"
          value={formik.values.name}
          onChange={formik.handleChange}
          isInvalid={!!formik.errors.name && formik.touched.name}
          errorMsg={formik.errors.name}
          onBlur={formik.handleBlur}
        />
        <div className="row">
          <div className="col-lg-6">
            <Form.Default
              id="streetAddress"
              placeholder="Enter Address"
              label="Address"
              className="mb-4"
              value={formik.values.streetAddress}
              onChange={formik.handleChange}
              isInvalid={!!formik.errors.streetAddress && formik.touched.streetAddress}
              errorMsg={formik.errors.streetAddress}
              onBlur={formik.handleBlur}
            />
          </div>
          <div className="col-lg-6">
            <Form.Default
              id="city"
              placeholder="Enter City"
              label="City"
              className="mb-4"
              value={formik.values.city}
              onChange={formik.handleChange}
              isInvalid={!!formik.errors.city && formik.touched.city}
              errorMsg={formik.errors.city}
              onBlur={formik.handleBlur}
            />
          </div>
        </div>
        <div className="row">
          <div className="col-lg-6">
            <Form.ReactSelect.Default
              id="state"
              placeholder="Enter State"
              label="State"
              className="mb-4"
              value={state.list.find((x) => formik.values.state === x.value)}
              onChange={(e) => {
                if (e) formik.setFieldValue('state', e.value);
              }}
              isInvalid={!!formik.errors.state && formik.touched.state}
              errorMsg={formik.errors.state}
              onBlur={formik.handleBlur}
              options={state.list}
              disabled={state.load}
            />
          </div>
          <div className="col-lg-6">
            <Form.Default
              id="zipCode"
              placeholder="Enter Zip Code"
              label="Zip Code"
              className="mb-4"
              value={formik.values.zipCode}
              onChange={formik.handleChange}
              isInvalid={!!formik.errors.zipCode && formik.touched.zipCode}
              errorMsg={formik.errors.zipCode}
              onBlur={formik.handleBlur}
            />
          </div>
        </div>
        <div className="row">
          <div className="col-lg-6">
            <CommissionType currentMode={commission.current} setCurrentMode={commission.setCurrent} />
          </div>
          <div className="col-lg-6">
            <Form.DefaultWithIcon
              id="comission"
              placeholder="Enter commision"
              className="mb-4"
              label="Enter Commision"
              type="number"
              rightIcon={commission.current === 1 ? <Percentage width={23} /> : <DollarSign width={23} />}
              value={formik.values.comission}
              onChange={formik.handleChange}
              isInvalid={!!formik.errors.comission && formik.touched.comission}
              errorMsg={formik.errors.comission}
              onBlur={formik.handleBlur}
            />
          </div>
        </div>
      </div>
      <div className={isEdit ? 'w-100 bg-stroke mb-4' : 'd-none'} style={{ height: '7px' }} />
      {partnerId && <PartnersEditBottomButton isLoading={updateLoad} isEdit={isEdit} />}
    </div>
  );

  if (formikParent) return renderFormContent();
  return (
    <form onSubmit={formik.handleSubmit}>
      {renderFormContent()}
    </form>
  );
}

export default PartnersPartner;
